import { DateTime } from 'luxon';
import { IAdminBookingDate } from '@pharmaplan/common';
import { MomentTimeFormats } from '../../../helpers/Constants';

const parseBookingDate = (date: string) =>
  DateTime.fromISO(date, { zone: 'utc' });

export const formatBookingDate = (date: string) =>
  parseBookingDate(date).toFormat(MomentTimeFormats.fullDate);

export const getBookingDateRange = (bookings: IAdminBookingDate[]) =>
  ({
    startDate: bookings[0]?.startDate ?? null,
    endDate: bookings[bookings.length - 1]?.endDate ?? null,
  });
